import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box, Flex, Heading, Select } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

function AreaChart({ datasets }) {
  const timeFrame = useSelector((state) => state.modal.timeFrame);
  const [value, setValue] = useState(datasets.filterBy[0].select);
  const [dataset, setDataset] = useState(datasets.filterBy[0]);

  const handleChange = event => {
    setValue(event.target.value);
    filterChart(event.target.value);
  };

  const filterChart = filterValue => {
    const filteredDataset = datasets.filterBy.find(
      dataset => dataset.select === filterValue
    );
    setDataset(filteredDataset);
  };

  useEffect(() => {
    if (timeFrame !== '') {
      setValue(timeFrame);
      const filteredDataset = datasets.filterBy.find(
        dataset => dataset.select === timeFrame
      );
      if (filteredDataset) {
        setDataset(filteredDataset);
      }
    }
  }, [timeFrame])

  const data = {
    labels: dataset.labels,
    datasets: dataset.data.map(dataset => ({
      ...dataset,
      label: dataset.label,
      backgroundColor: dataset.borderColor,
      borderColor: dataset.borderColor,
      data: dataset.value,
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: { family: 'Montserrat', size: '14' },
          color: '#000',
          usePointStyle: true
        },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Jumlah Total',
        },
        min: 0,
        ticks: {
          stepSize: 10,
        },
      },
    },
  };

  return (
    <Box
      bg="white"
      overflow="hidden"
      borderRadius="8px"
      border="1px solid"
      borderColor="dietela.primary"
    >
      <Box bg="dietela.primary" p="5">
        <Heading size="sm" color="white">
          {datasets.title}
        </Heading>
      </Box>
      <Flex flexDirection="column" p="5">
        <Select
          className="timeframe-selector"
          value={value}
          onChange={handleChange}
          mb={10}
          width={'50%'}
          bg={'#F8F9FA'}
          variant={'filled'}
          border={'1px solid'}
          borderColor={'#DDDDDD'}
          _focus={{
            border: '2px solid',
            borderColor: 'dietela.primary',
            boxShadow: 'none',
          }}
        >
          {datasets.filter.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>
        <Line data={data} options={options} />
      </Flex>
    </Box>
  );
}

export default AreaChart;
